import React, { Component } from 'react';
import axios from 'axios';
import Navbar from './Navbar';
import Footer from './Footer';
import Search from './Search';
import Search2 from './Search2';

class Home extends Component {
	render() {
		return (
			<div>
				<Navbar />
				{/* <Search /> */}
				<Search2 />
				<br />
				<br />
				<Footer />
			</div>
		);
	}
}

export default Home;
